import * as types from "../types";
import Cookies from "js-cookie";

export default function authActions(state, dispatch) {
  return {
    setUser: (user) => {
      Cookies.set("ongage-automations-auth", JSON.stringify(user), {
        expires: new Date(new Date().getTime() + user.expiresIn * 1000),
      });
      dispatch({
        type: types.SET_USER,
        user,
      });
    },
    getUser: () => {
      const user = Cookies.get("ongage-automations-auth");

      user &&
        dispatch({
          type: types.SET_USER,
          user: JSON.parse(user),
        });

      dispatch({ type: types.USER_LOADED });
    },
    removeUser: () => {
      Cookies.remove("ongage-automations-auth");
      dispatch({ type: types.REMOVE_USER });
    },
  };
}
